import { useQuery } from 'convex/react';
import { api } from '@convex/_generated/api';

export function useConvexOAuthToken() {
  const token = useQuery(api.sessions.getConvexOAuthToken);
  return token;
}
